import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {nullableBool} from "../../../../helpers/nullable-bool";

class DeviceGroupForm extends Component {

    state = {
        id: null,
        label: '',
        isDefault: false,
        showOnDashboard: null,
    };

    componentDidMount() {
        const {data} = this.props;
        if(data) {
            this.setState({
                id: data.id,
                label: data.label,
                isDefault: data.isDefault,
                showOnDashboard: data.showOnDashboard
            });
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    };

    handleOnChangeCheckbox = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.checked
        });
    };

    handleSelectInput = (e) => {
        console.log(e.target.value);
        this.setState({
            ...this.state,
            [e.target.name]: nullableBool.stringToBool(e.target.value)
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const {submit} = this.props;
        submit(this.state);
    };

    render() {
        const { t } = this.props;
        return (
            <div>
                <form onSubmit={this.handleSubmit }>
                    <div className="form-group">
                        <label className="col-form-label"> {t('label')} </label>
                        <input
                            type="text"
                            className="form-control"
                            name="label"
                            value={this.state.label}
                            onChange={this.handleOnChangeInput}
                            required />
                    </div>

                    <div className="form-group">
                        <label htmlFor="isDefault" className="col-form-label"> {t('is-default')} </label>
                        <input
                            type="checkbox"
                            className="form-check"
                            name="isDefault"
                            id="isDefault"
                            onChange={this.handleOnChangeCheckbox}
                            checked={this.state.isDefault || false}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="showOnDashboard" className="col-form-label"> {t('show-on-dashboard')} </label>
                        <select
                            className="form-control"
                            name="showOnDashboard"
                            onChange={this.handleSelectInput}
                            value={nullableBool.check(this.state.showOnDashboard)}
                        >
                            <option value={"null"}>{t('standard')}</option>
                            <option value={"true"}>{t('power-management')}</option>
                            <option value={"false"}>{t('no-render-dashboard')}</option>
                        </select>
                    </div>

                    <div className="form-group float-right">
                        { this.state.id ? (
                            <button type="submit" className="btn btn-primary">
                                <i className="fas fa-edit"> </i> {t('save-changes')}
                            </button>
                        ) : (
                            <button type="submit" className="btn btn-success">
                                <i className="fas fa-edit"> </i> {t('create')}
                            </button>
                        )}
                    </div>
                </form>
            </div>
        )
    }
};
export default withNamespaces()(DeviceGroupForm);
